module.exports = __webpack_public_path__ + "img/운디네.839d7dd5.png";